export const isOneTermItemPresent = (
  noeEntekhab,
  turnBase,
  steps,
  turnBaseData
) => {
  const condition =
    (Number(noeEntekhab) === 3 &&
      steps === 2 &&
      turnBase === 'speciality' &&
      turnBaseData.specialityBased.length === 1) ||
    (Number(noeEntekhab) === 3 &&
      steps === 2 &&
      turnBase === 'service' &&
      turnBaseData.serviceBased.length === 1);

  return condition;
};
